import styled from 'styled-components';

export const MainWrap = styled.div`
  .path-lock-panel[style*='direction: rtl;'] {
    .rtl-ml-5 {
      margin-left: 5px;
    }
    .rtl-mr-5 {
      margin-right: 5px;
    }
    .rtl-icon-rotate {
      transform: rotate(180deg);
    }
  }
  &.path-lock-panel-wrap {
    bottom: 50px;
    width: 100%;
    position: fixed;
    z-index: 1;
    align-items: center;
    justify-content: center;
    display: flex;
    flex-direction: column-reverse;
    height: auto;
    /* z-index: 31; */
    pointer-events: none;
    text-align: center;

    &.regular.mobile {
      /* z-index: 16; */
      align-items: end;

      .path-lock-panel {
        border-radius: 50px;
        max-width: 90vw;
      }
    }

    .bt-audio-subs {
      position: initial;
      margin-bottom: 5px;
      bottom: initial;
    }
  }

  .glpm-deskWrap {
    margin-right: 10px;
  }

  .path-lock-panel {
    min-height: 64px;
    margin: 0 10px;

    min-width: 485px;
    max-width: 678px;

    display: flex;
    justify-content: space-between;
    align-items: center;
    backdrop-filter: blur(7.5px);
    border-radius: 20px;
    padding: 14px;
    font-size: 17px;
    z-index: 1;
    opacity: 0; //appear animation will change this to 1
    pointer-events: all;

    &:not(.delayedDisable) {
      animation: 1s ease 0s 1 normal forwards running alert-toast-appear;
    }
    &.noDesk {
      .glpm-stepsDesk {
        display: none;
      }
    }
    .path-lock-titleWrap {
      display: flex;
    }

    .glpm-stepsDesk {
      display: flex;
      align-items: center;
      margin: 0 15px;
      color: black;
      background: #ffffff;
      border-radius: 8.875px;
      font-style: normal;
      font-weight: 400;
      font-size: 13px;
      letter-spacing: 0.133125px;

      height: 23px;
      display: flex;
      align-items: center;

      padding: 0 6px;
      white-space: nowrap;
      margin: 0;
    }
    .avatar {
      object-fit: cover;
      border-radius: 50%;
      width: auto;
      height: 50px;
    }

    .pf-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 36px;
      cursor: pointer;
      text-decoration: none;

      i {
        color: white;
      }

      .btn-text {
        font-size: 15px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    .path-lock-title {
      font-weight: bold;
      font-size: 15px;
      margin-bottom: 4px;
      text-align: left;
      margin-right: 4px;
    }

    .prev-btn {
      margin-right: 6px;
      border-radius: 68px;
      padding: 0 24px;

      &:hover {
        box-shadow: inset 0px 0px 100px 0 #0000001c;
      }

      i {
        font-size: 20px;
      }
    }

    .next-btn {
      /* width: 100px; */
      border-radius: 35px;
      padding: 0 15px;

      &:hover {
        box-shadow: inset 0px 0px 100px 0 #0000001c;
      }
      &:disabled {
        cursor: default;
      }

      span {
        margin-right: 13px;
        align-items: center;
        display: flex;
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 26px;
        text-transform: uppercase;
      }

      i {
        font-size: 20px;
      }
    }

    .path-lock-description {
      font-size: 15px;
      /* max-height: 37px; */
      min-height: 18px;
      /* overflow-y: auto; */
      overflow: hidden;
      width: 100%;
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 400;
      line-height: 105%;
      align-items: center;
      letter-spacing: 0.15px;
      color: #333333;
      text-align: left;
    }

    .path-lock-iconWrap {
      /* min-width: 50px; */
      /* min-height: 50px; */
      align-self: start;
      max-width: 50px;
      max-height: 50px;
      margin-right: 10px;
      overflow: hidden;
      border-radius: 9px;
      &.bigger {
        max-width: 60px;
        max-height: 60px;
      }
      img {
        object-fit: cover;
        width: 100%;
        height: 100%;
      }
    }

    .glpm-navWrap {
      align-items: center;
      display: flex;
      flex-wrap: nowrap;

      .glpm-stepsDesk-btns {
        display: none;
      }
    }

    &.noDesk {
      .glpm-navWrap {
        .glpm-stepsDesk-btns {
          margin-right: 4px;
          display: flex;
        }
      }
    }

    @media screen and (max-width: 500px) and (max-height: 510px), screen and (max-height: 500px) {
      width: calc(100% - 50px);
      align-self: start;
    }
  }

  @media screen and (max-width: 480px) {
    .path-lock-panel {
      /* max-height: initial; */
      flex-direction: column;

      .glpm-stepsDesk {
        display: block;
      }
      .glpm-stepsDesk-btns {
        display: none;
      }
      .path-lock-iconWrap {
        display: none;
      }
      .path-lock-titleWrap {
        font-size: 14px;
      }
      .path-lock-title {
        margin-right: 68px; //if there is step display
        font-size: 11px;
      }
      .glpm-stepsDesk {
        white-space: nowrap;
        position: absolute;
        top: -14px;
        right: -5px;
        font-size: 11px;
        padding: 0 6px;
        margin: 0px 25px;
      }
      .path-lock-description {
        font-size: 14px;
      }
      .pf-btn {
        height: 30px;
      }
      .pf-btn span {
      }
      .glpm-navWrap {
        margin-top: 6px;
        width: 100%;
        text-align: center;
        justify-content: center;
      }
      .next-btn {
        width: 100%;
      }
      .prev-btn {
        min-width: calc(30% - 5px);
      }
      .btn-text {
        font-size: 13px;
      }
    }
    /* hide on small screen 480px */
  }
  @media screen and (max-width: 678px) {
    .path-lock-panel {
      max-width: 100%;
      min-width: 220px;
    }
  }

  @keyframes alert-toast-appear {
    from {
      transform: translate(0px, 100px);
      opacity: 0;
    }

    to {
      transform: none;
      opacity: 1;
    }
  }
`;

export const PathSelectModal = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  z-index: 999;
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(7.5px);
  border-radius: 20px 20px 0px 0px;
  padding: 20px;
  color: white;
  font-size: 16px;
  max-height: 90vh;
  padding-top: 0;

  animation: 1s ease 0s 1 normal forwards running alert-toast-appear;

  .psm-header {
    display: flex;
    justify-content: space-between;

    align-items: center;
    margin-bottom: 3px;
  }
  .psm-closeBlock {
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .psm-item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 13px;
    background: rgba(0, 0, 0, 0.18);
    border-radius: 15px;
    padding: 6px 7px;
  }
  .psm-imgWrap {
    width: 40px;
    height: 40px;
    border-radius: 9px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    margin-right: 7px;
  }
  .psm-name {
    font-size: 14px;
  }
  .psm-next {
    margin-right: 17px;
    align-items: center;
    display: flex;
  }
  .psm-steps {
    font-size: 12px;
  }
  .psm-imgDeskWrap {
    display: flex;
  }
  i {
    font-size: 16px;
  }
`;
